import script from "./IndexBloodingModalWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndexBloodingModalWindow.vue?vue&type=script&setup=true&lang=ts"

import "./IndexBloodingModalWindow.vue?vue&type=style&index=0&id=e8f731f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8f731f0"]])

export default __exports__